import React from 'react';
import { ReactComponent as MicrosoftIcon } from 'new/components/icons/microsoft.svg';

class MicrosoftLoginView extends React.Component {
  render() {
    return (
      <button
        type="button"
        style={{
          marginTop: 20,
          marginBottom: 'var(--spacing-sm)',
          border: '1px solid #8c8c8c',
          color: '#5e5e5e',
          fontSize: 'var(--font-size-base)',
          fontWeight: 'var(--font-weight-medium)',
          width: '100%',
          borderRadius: 4,
          display: 'flex',
          alignItems: 'center',
          backgroundColor: 'white',
          cursor: 'pointer',
          padding: '10px 0',
        }}
        className="signout-button hover"
        onClick={this.props.onSubmit}
      >
        <MicrosoftIcon style={{ width: 20, marginLeft: 12 }} />
        <div
          style={{
            flexGrow: 1,
            verticalAlign: 'top',
            textAlign: 'center',
            marginLeft: '-12px',
          }}
        >
          {this.props.label || 'Sign in with Microsoft'}
        </div>
      </button>
    );
  }
}

export default MicrosoftLoginView;
